export default {
  // Page titles
  overview: {
    title: '数据概览',
    jobOverview: '职位概览',
    jobOverviewInfo: '基于已创建的职位统计',
    selectionProgress: '选考进度',
    selectionProgressInfo: '基于进行中的选考统计，不包含已入职和已终止',
    jobSelectionProgress: '不同职位选考进展',
    conversionRate: '转化率',
    conversionFunnel: '转化率趋势',
    conversionFunnelInfo: '基于所有历史选考记录统计',
    notRecruitedJobs: '待发布职位数',
    recruitingJobs: '已发布职位数',
    closedJobs: '已关闭职位数',
    openToAgentJobs: '对猎头开放职位数',
    interviewingJobs: '选考中',
    totalCandidates: '候选人总数',
    documentReview: '简历筛选',
    interview: '面试',
    internalSelection: '内定',
    entry: '入职',
    rejection: '不录用',
    jobTitle: '职位',
    recruitCount: '招聘人数',
    enteredCount: '已入职',
    inProgress: '选考流程中',
    interviewPending: '面试待约',
    interviewWaitAccept: '面试待接受',
    interviewWaiting: '面试待面',
    interviewAdjust: '面试待调整',
    interviewExpired: '面试已过期',
    interviewResultPending: '面试结果待确认',
    internalOffer: '内定',
    offerLetterPending: '内定通知书待发送',
    offerResultPending: '内定承诺结果待确认',
    confirmEntryDate: '待确认入职日期',
    confirmEntry: '待入职',
    totalApplications: '总投递数',
    documentReviewRate: '简历筛选',
    interviewRate: '面试',
    internalRate: '内定',
    entryRate: '已入职',
    pendingOnboarding: '待入职',
    overallConversionRate: '整体转化率',
    updateTime: '更新时间',
    downloadExcel: '导出Excel',
  },
  headhunter: {
    title: '猎头推荐看板',
    placeholder: '开发中...',
    progress: '猎头推荐进展',
    progressInfo: '基于进行中的选考统计（仅猎头推荐的候选人），不包含已入职和已终止',
    differentHeadhunters: '不同猎头推荐进展',
    headhunterCompany: '猎头公司',
    conversion: '猎头推荐转化',
    conversionInfo: '基于合作猎头推荐的所有历史选考记录统计',
    differentHeadhuntersConversion: '不同猎头推荐转化',
    totalApplications: '总投递数',
    joined: '已入职',
    chartTitle: '猎头推荐转化率',
    allHeadhunters: '所有猎头',
  },
  internal: {
    title: '自社推荐看板',
    placeholder: '开发中...',
    progress: '自社推荐进展',
    progressInfo: '基于进行中的选考统计（仅自社推荐的候选人），不包含已入职和已终止',
    differentChannels: '不同应聘渠道进展',
    channel: '应聘渠道',
    conversion: '自社推荐转化',
    conversionInfo: '基于自社推荐的所有历史选考记录统计',
    differentChannelsConversion: '不同应聘渠道转化',
    totalApplications: '总投递数',
    joined: '已入职',
    chartTitle: '自社推荐转化率',
  },
  myBoard: {
    title: '我的看板',
    placeholder: '开发中...',
    myResponsible: '我负责的选考',
    myResponsibleInfo: '基于进行中的选考统计（仅我负责的选考），不包含已入职和已终止',
    differentJobs: '不同职位选考进展',
    differentHeadhunters: '不同猎头推荐进展',
    headhunterCompany: '猎头公司',
    internalDifferentChannels: '自社推荐不同应聘渠道进展',
    channel: '应聘渠道',
  },
  agent: {
    title: '数据概览',
    recruitmentOverview: '招聘概览',
    recruitmentOverviewInfo: '基于已开放的职位及投递情况统计',
    jobAndApplicationSummary: '职位及投递汇总',
    recruitingCompany: '招聘企业',
    openPositions: '开放职位数',
    totalRecruitment: '招聘总人数',
    totalApplications: '总投递数',
    enteredCount: '已入职人数',
    selectionProgress: '选考进展',
    selectionProgressInfo: '基于进行中的选考统计，不包含已入职和已终止',
    differentCompaniesProgress: '不同企业选考进展',
    differentManagersProgress: '不同负责人选考进展',
    manager: '负责人',
    inProgress: '选考流程中',
    documentReview: '简历筛选',
    interviewPending: '面试待约',
    interviewWaitAccept: '面试待接受',
    interviewWaiting: '面试待面',
    interview: '面试',
    interviewAdjust: '面试待调整',
    interviewExpired: '面试已过期',
    interviewResultPending: '面试结果待确认',
    internalOffer: '内定',
    offerLetterPending: '内定通知书待发送',
    offerResultPending: '内定承诺结果待确认',
    confirmEntryDate: '待确认入职日期',
    confirmEntry: '待入职',
    conversionAnalysis: '选考转化',
    conversionAnalysisInfo: '基于所有历史选考记录统计',
    overallConversionRate: '整体转化率',
    differentCompaniesConversion: '不同企业转化',
    differentManagersConversion: '不同负责人转化',
    myBoardTitle: '我的看板',
    jobAndMyApplicationSummary: '职位及我的投递汇总',
    jobAndMyApplicationTableTitle: '我的投递汇总',
    jobAndMyApplicationSummaryInfo: '基于已开放的职位及我负责的投递统计',
    mySelectionProgress: '我的选考进展',
    mySelectionProgressInfo: '基于进行中的选考统计（仅我负责的选考），不包含已入职和已终止',
    differentJobsProgress: '不同职位选考进展',
    jobInfo: '职位',
    myConversionAnalysis: '我的选考转化',
    myConversionAnalysisInfo: '基于我负责的所有历史选考记录统计',
    differentJobsConversion: '不同职位转化',
  },
};
